import { LocalOffer } from "@mui/icons-material";
import { Stack, Typography } from "@mui/material";

type CouponType = {
  name: string;
  amount: number;
};

interface Props {
  coupon: CouponType;
}

const CouponView = ({ coupon }: Props) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography
        component={Stack}
        direction="row"
        alignItems="center"
        gap={1}
        fontSize={"18px"}
        color="success"
      >
        {coupon.name} <LocalOffer />
      </Typography>
      <Typography fontSize={"18px"} color="success">
        -${coupon.amount}
      </Typography>
    </Stack>
  );
};

export default CouponView;
